import {
  Card,
  Icon,
  Typography,
  IconButton,
  Stack,
  Tooltip,
  Pagination,
  Switch,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Header from "layouts/profile/components/Header";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCategory } from "redux/festures/categorySlice";
import MDAvatar from "components/MDAvatar";
import { getSubCategory } from "redux/festures/categorySlice";
import SkLoading from "components/SkLoading";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Cancel,
  Close,
  Delete,
  Edit,
  Input,
  PhotoCamera,
  Visibility,
  WifiTetheringTwoTone,
} from "@mui/icons-material";
import SkModal from "components/SkModal";
import MDInput from "components/MDInput";
import { creatCategoryData } from "redux/festures/categorySlice";
import { deleteCategory } from "redux/festures/categorySlice";
import { handleAlert } from "redux/festures/alertSlice";
import { updateCategory } from "redux/festures/categorySlice";
import ImagePicker from "components/ApnaUploader";
import { getGlobalCategory } from "redux/festures/categorySlice";
import { getSubGlobalCategory } from "redux/festures/categorySlice";
import SkConfirm from "components/SkComfirm";
import ApnaSelect from "components/ApnaSelect/ApnaSelect";
import { getAllCity } from "redux/festures/citySlice";
import { useLocation } from "react-router-dom";
import ApnaSelect2 from "components/ApnaSelect";
import { unlinkImage } from "redux/festures/categorySlice";
import AstrieskIcon from "components/AstrieskIcon";
import SubcategoryUpdate from "./SubcategoryUpdate";
import SingleCategory from "./SingleCategory";
import PcatogeroyUpdate from "./PcatogeroyUpdate";
import { disableCategory } from "redux/festures/categorySlice";

const Category = () => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const admin = localStorage.getItem("admin_id");
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const {
    Loading,
    category,
    subCategory,
    IsLoading,
    isPages,
    subCategoryData,
    createUpdateLoading,
  } = useSelector((state) => ({
    ...state.isCategory,
  }));
  const { city } = useSelector((data) => ({ ...data?.isCity }));
  const [ecom, setEcom] = useState(false);

  const [rowsData, setRowsData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenUpdate2, setIsOpenUpdate2] = useState(false);
  const [isOpenView, setIsOpenView] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [isUpdates, setIsUpdate] = useState(false);
  const [isPUpdates, setIsPUpdate] = useState(false);
  const [isSwitch, setIsSwitch] = useState(false);
  const [isOpenDialog, setIsOpenDialog] = useState({ open: false, isId: null });
  const [filter, setFilter] = useState(false);
  const [pagess, setPagess] = useState(1);

  const adminId = localStorage.getItem("admin_id");

  useEffect(() => {
    if (!adminId) return;

    dispatch(
      getGlobalCategory({
        adminId,
        filter,
        page: pagess,
      })
    );
  }, [filter, pagess, adminId]);
  useEffect(() => {
    if (category && category.length > 0) {
      const temprows = category.map((value, index) => ({
        no: (
          <MDTypography sx={{ fontSize: 12, fontWeight: "medium" }} variant="text">
            {(pagess - 1) * 10 + index + 1}
          </MDTypography>
        ),
        "category details": (
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: 0.5,
            }}
          >
            <MDBox sx={{ height: 40, width: 40 }}>
              <img
                src={`${process.env.REACT_APP_URI}${value?.icon}`}
                alt={"img"}
                onError={(e) => {
                  (e.onError = null), (e.target.src = require("../../assets/images/bg-profile.png"));
                }}
                style={{ width: "100%", height: "100%", borderRadius: "50%" }}
              />
            </MDBox>
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 0.5,
                flexDirection: "column",
              }}
            >
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
                style={{
                  maxWidth: "250px",
                  lineHeight: "20px",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Name: {value?.name || "N/A"}
              </MDTypography>
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
                fontSize={10}
              >
                CategoryID: {value?._id || "N/A"}
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
        view: (
          <IconButton
            aria-label="action_view"
            onClick={() => {
              setViewData(value);
              setIsOpenView(true);
            }}
          >
            <Visibility
              sx={({ palette: { dark, white, info } }) => ({
                color: darkMode ? info.main : dark.main,
              })}
            />
          </IconButton>
        ),
        disable: (
          <Tooltip title={value?.disable ? "Move to Active" : "Move to Inactive"}>
            <Switch
              value={value?.disable}
              checked={value?.disable}
              color="info"
              onChange={() => handleBinSwitch(value?._id)}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Tooltip>
        ),
        action: (
          <IconButton
            aria-label="action_edit"
            onClick={() => {
              setIsOpenUpdate(true);
              setViewData(value);
              setIsPUpdate(true);
            }}
          >
            <Edit
              sx={({ palette: { dark, white, info } }) => ({
                color: darkMode ? info.main : dark.main,
              })}
            />
          </IconButton>
        ),
      }));
      setRowsData(temprows);
    } else {
      setRowsData(["", " "]);
    }
  }, [category]);

  const columns = {
    AllCategories: [
      { Header: "S.No", accessor: "no" },
      { Header: "category details", accessor: "category details" },
      { Header: "Disable", accessor: "disable" },
      { Header: "view", accessor: "view" },
      { Header: "action", accessor: "action" },
    ],
  };

  const [file, setFile] = useState();
  const [profile, setProfile] = useState({
    categoryName: "",
    uploadPic: "",
    bannerImage: "",
    bannerVideo: "",
    cityId: [],
    categoryId: "",
    category__Id: "",
    isShow: "",
    serverBannerImage: null,
  });

  const handleBinSwitch = (value) => {
    dispatch(
      disableCategory({
        url: `${process.env.REACT_APP_APII}/eCommerce/disableCategory/${value}/${adminId}`,
      })
    ).then((data) => {
      dispatch(
        handleAlert({
          isOpen: true,
          type: data?.payload?.success ? "success" : "error",
          msg: data?.payload?.message,
        })
      );

      if (data?.payload?.success) {
        setFilter(0);   // 👈 IMPORTANT FIX
        setPagess(1);

        dispatch(
          getGlobalCategory({
            adminId,
            filter: 0,
            page: 1,
          })
        );
      }

    });
  };


  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mb={2} />
        <MDBox py={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <MDTypography variant="h6" color="white">
                Category Table
              </MDTypography>
              <MDButton
                variant="gradient"
                disabled={Loading}
                color="dark"
                sx={({ palette: { dark, white, info } }) => ({
                  color: white.main,
                  backgroundColor: dark.main,
                  "&:hover": {
                    color: white.main,
                    backgroundColor: dark.main,
                  },
                })}
                onClick={() => {
                  setIsOpenUpdate(true);
                  setIsPUpdate(false);
                }}
              >
                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                &nbsp; Create Category
              </MDButton>
            </MDBox>

            <MDBox pt={3} width={"100%"}>
              {Loading ? (
                <SkLoading />
              ) : category && category.length ? (
                <>
                  <DataTable
                    table={{
                      columns: columns?.AllCategories,
                      rows: rowsData,
                    }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                    canSearch={false}
                    pagination={false}
                    isPagination={false}
                  />
                  <MDBox
                    sx={{
                      mt: 5,
                      mb: 2,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack spacing={2} direction={"row"}>
                      <Pagination
                        sx={({ palette: { dark, white, info } }) => ({
                          "&.MuiPaginationItem-text": {
                            color: darkMode ? white.main : dark.main,
                          },
                          "&	.MuiPaginationItem-icon": {
                            color: darkMode ? white.main : dark.main,
                          },
                          "&		.MuiPaginationItem-textInfo": {
                            color: darkMode ? white.main : dark.main,
                          },
                        })}
                        color="info"
                        variant="text"
                        count={isPages || 1}
                        page={pagess}
                        onChange={(e, value) => setPagess(value)}
                      />
                    </Stack>
                  </MDBox>
                </>
              ) : (
                <MDTypography
                  display="block"
                  variant="h6"
                  fontWeight="medium"
                  ml={1}
                  lineHeight={1}
                  align="center"
                  py={3}
                >
                  Category Is Not Founds ...
                </MDTypography>
              )}
            </MDBox>
          </Card>
        </MDBox>
        <Footer />
      </DashboardLayout>
      <SkModal
        show={isOpenView}
        unShow={setIsOpenView}
        width={{ sx: "100%", md: "50%", xl: "50%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <SingleCategory viewData={viewData} />
      </SkModal>

      <SkModal
        show={isOpenUpdate}
        unShow={setIsOpenUpdate}
        width={{ sx: "100%", md: "50%", xl: "50%", sm: "100%" }}
        height={"80%"}
        padding={3}
        overflowY={true}
      >
        <PcatogeroyUpdate
          viewData={viewData}
          isPUpdates={isPUpdates}
          setIsOpenUpdate={setIsOpenUpdate}
          filter={filter}
        />
      </SkModal>
      <SkModal
        show={isOpenUpdate2}
        unShow={setIsOpenUpdate2}
        width={{ sx: "100%", md: "50%", xl: "50%", sm: "100%" }}
        height={"80%"}
        overflowY={true}
        padding={3}
      >
        <SubcategoryUpdate
          viewData={viewData}
          isUpdates={isUpdates}
          setIsOpenUpdate2={setIsOpenUpdate2}
          filter={filter}
        />
      </SkModal>
      <SkConfirm
        dialogTitle={"Delete"}
        dialogContent={"Are you sure you want to delete this category?"}
        open={isOpenDialog}
        setOpen={setIsOpenDialog}
        dialogAction={
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 3,

              px: 3,
            }}
          >
            <MDButton
              variant="gradient"
              color="info"
              sx={{ width: "50%" }}
              onClick={() => {
                setIsOpenDialog((Preview) => ({
                  ...Preview,
                  open: false,
                  isId: null,
                }));
              }}
            >
              Cancel
            </MDButton>
            <MDButton
              variant="gradient"
              sx={{ width: "50%" }}
              color="error"
              onClick={() => {
                dispatch(
                  deleteCategory({
                    url: `${process.env.REACT_APP_API}/deleteCategory/${isOpenDialog?.isId}/${admin}`,
                  })
                ).then((data) => {
                  dispatch(
                    handleAlert({
                      isOpen: true,
                      type: `${data?.payload?.success ? "success" : "error"}`,
                      msg: data?.payload?.message,
                    })
                  );
                  if (data?.payload?.success) {
                    dispatch(
                      getGlobalCategory({
                        adminId,
                        filter,
                        page: pagess,
                      })
                    );

                    dispatch(
                      getSubGlobalCategory(`/eCommerce/getAllCategoryByAdmin/${adminId}?disable=${filter === false ? false : filter || ""
                        }&page=${page || ""}`)
                    );
                    setIsOpenDialog((Preview) => ({
                      ...Preview,
                      open: false,
                    }));
                  }
                  setIsId(isOpenDialog?.isId);
                });
              }}
            >
              yes
            </MDButton>
          </MDBox>
        }
      />
    </>
  );
};

export default Category;
